import { create } from "zustand";
import type { ConfigName } from "../types/config-name";

type TermsAgreementState = {
  acceptedConfigs: Partial<Record<ConfigName, boolean>>;
  acceptTerms: (configName: ConfigName) => void;
  clearTermsAgreement: () => void;
};

export const useTermsAgreementState = create<TermsAgreementState>((set) => ({
  acceptedConfigs: {},
  acceptTerms: (configName) =>
    set((state) => ({
      acceptedConfigs: { ...state.acceptedConfigs, [configName]: true },
    })),
  clearTermsAgreement: () => set({ acceptedConfigs: {} }),
}));
